import React, { useState } from 'react';
import { Checkbox, CheckboxChangeEvent } from 'primereact/checkbox';
import { Dialog } from 'primereact/dialog';
import { AddNewDocFeedback } from '../../../pages/docs/componenets/add-new-doc-feedback';
import { UserSummaryType } from '../../../../../api/types/user/user-summary.type';
import { FileUploadFile } from 'primereact/fileupload';
import { toast } from 'react-toastify';

export const UserPageLecturerAddDoc: React.FC<{
  user: UserSummaryType;
  onFeedbackSubmit: (
    userId: number,
    docId: number,
    value: string,
    file: FileUploadFile,
  ) => any;
}> = ({ user, onFeedbackSubmit }) => {
  const [addDocDialog, setAddDocDialog] = useState(false);
  const [checked, setChecked] = useState(false);
  const [fileName, setFileName] = useState('');

  const onFeedbackSubmitDialog = (
    userId: number,
    docId: number,
    value: string,
    file: FileUploadFile | undefined,
  ) => {
    if (!file) {
      toast.warn('יש לבחור קובץ');
      return;
    }
    onFeedbackSubmit(user.id, docId, value, file);
    setFileName(value);
    setAddDocDialog(false);
    setChecked(true);
  };
  return (
    <div>
      <div style={{ marginTop: '16px', display: 'flex', flexDirection: 'row' }}>
        <Checkbox
          checked={checked}
          onChange={(event: CheckboxChangeEvent) =>
            setAddDocDialog(event.checked)
          }
        />
        <div style={{ marginRight: '8px' }}>
          {checked ? `נקלט המסמך: ${fileName}` : 'לחץ להוספת חוזה'}
        </div>
      </div>

      <Dialog
        header="הוספת חוזה"
        visible={addDocDialog}
        onHide={() => setAddDocDialog(false)}
        style={{
          width: '500px',
          backgroundColor: 'white',
          borderRadius: '8px',
        }}
      >
        <AddNewDocFeedback
          userId={user.id}
          docId={1}
          onFeedbackSubmit={onFeedbackSubmitDialog}
          uploadFileBodyText={'גרור לכאן חוזה'}
        />
      </Dialog>
    </div>
  );
};
